<template>
  <div class="sv sv007">
    <div class="container">
      <BreadcrumbGroup :items="breadcrumbItems" />

      <ContentsHeader class="-blue" src="sv007/main.jpg">
        <p class="heading1">教えて！みんなのローン活用術</p>
        <h1 class="heading2">
          せっかくの卒業旅行、<br />お金のことであきらめないで！
        </h1>
      </ContentsHeader>
    </div>

    <div class="container">
      <ContentsIntro
        class="-blue _pt-sm-60"
        icon-left="sv007/avatar-a.gif"
        name-left="Aさん"
        icon-right="sv007/avatar-b.gif"
        name-right="Bさん"
        txt-relation="同じゼミの友人"
      >
        卒業旅行の計画を立てているAさんとBさん。でも、Bさんはお金の都合で参加を諦めかけているようです。<br />
        そんな話を聞いたAさんは先輩の体験談を紹介します。
      </ContentsIntro>
    </div>

    <hr class="-pcnone _mb-sm-60" />

    <div class="container">
      <TalkGroup>
        <TalkBox src="sv007/avatar-a.gif"
          >3月の卒業旅行どうしようか？Bさんももちろん行くよね？</TalkBox
        >
        <TalkBox src="sv007/avatar-b.gif"
          >もちろん行きたい！せっかくだから海外とか行きたいけど…結構お金かかるよね？</TalkBox
        >
        <TalkBox src="sv007/avatar-a.gif"
          >他の子たちとも相談して国内にしようかって話になってるよ。沖縄や北海道だと旅行費用が10万を超えちゃうみたいだから、近場で3万円くらいに抑えようかって…</TalkBox
        >
        <TalkBox src="sv007/avatar-b.gif"
          >3万円なら何とかなるかも。バイトのシフト増やしてもらえるか相談してみるね</TalkBox
        >
      </TalkGroup>

      <section>
        <HeadingTwo class="_mt-md-110 _mt-sm-60"
          >せっかくの卒業旅行！<br class="-pcnone" />
          資金不足で諦める前に…</HeadingTwo
        >

        <TalkGroup src="sv007/img02.jpg">
          <TalkBox src="sv007/avatar-a.gif"
            >ちなみに旅行費用は前払いなんだけど、大丈夫そうかな？</TalkBox
          >
          <TalkBox src="sv007/avatar-b.gif"
            >バイトのお給料が入るのは、旅行の直前のなんだ。それだと間に合わないかな？</TalkBox
          >
          <TalkBox src="sv007/avatar-a.gif"
            >実は早期割引プランで、同じ料金でワンランク上のサービスが受けられますよって勧められたの。せっかくだからちょっと贅沢したいなって思ってるんだけど…申し込みから1週間以内に振り込まないといけないんだ</TalkBox
          >
        </TalkGroup>

        <TalkGroup class="_mb-60">
          <TalkBox src="sv007/avatar-b.gif"
            >確かに、せっかくの卒業旅行だし妥協はしたくない！でも、今月末にはってことだよね…。実は、車の免許もこの時期に取らなくちゃいけなくて、教習所の合宿代を払ったら旅行代金の支払いは難しいかも…。親にも負担かけたくないし、今回は諦めようかな…</TalkBox
          >
          <TalkBox src="sv007/avatar-a.gif"
            >え～残念だよ。でも無理にとは言えないからな…、そういえば、先輩はau
            PAY
            スマートローンで借りたって言ってた。月々の返済も定額なので安心だって。</TalkBox
          >
          <TalkBox src="sv007/avatar-b.gif"
            >そんなサービスがあるんだ！月々の返済が定額なら、計画的に利用ができそう。考えてみたい！</TalkBox
          >
        </TalkGroup>

        <ContentsCard class="-blue _mb-sm-30">
          <div class="card-header">
            <IconBox src="light-blue" class="-md _mb-sm-10"></IconBox>
            <h3 class="heading">
              au PAY スマートローンなら<br class="-pcnone" />こんなに便利！
            </h3>
          </div>
          <div class="card-body01">
            <p class="txt01">
              ご利用限度額は、１万円~100万円（※）まで。カードレスでご利用はすべてスマートフォンで完結するのでとっても便利！
            </p>
            <ListGroup class="-note">
              <ListItem class="-note -textcenter _mb-25"
                >実際のご契約条件は、お申し込み後の審査に基づきご提示させていただきます。
              </ListItem>
            </ListGroup>

            <div class="card-groups">
              <div class="card-box">
                <div class="card-image -width90">
                  <img
                    src="@/assets/images/sv/sv007/img03.jpg"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="card-body">
                  お借り入れは1万円から！一時的に資金が足りないときに頼れる味方です。
                </div>
              </div>
              <div class="card-box">
                <div class="card-image -width80">
                  <img
                    src="@/assets/images/sv/sv007/img04.jpg"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="card-body">
                  スマートフォンがあれば、新規お申し込みもお借り入れもかんたんWEB完結！
                </div>
              </div>
              <div class="card-box">
                <div class="card-image -width80">
                  <img
                    src="@/assets/images/sv/sv001/img07.gif"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="card-body">
                  au PAY
                  残高にそのままチャージができます。チャージした残高は、au PAY
                  プリペイドカードやau
                  PAYで全国のコンビニ・スーパーやMastercard®加盟店、au
                  PAY加盟店などいろいろな場所で使え、Pontaポイントもたまります。
                </div>
              </div>
            </div>
          </div>
        </ContentsCard>
      </section>

      <section class="_mb-md-60">
        <HeadingTwo class="_mt-md-110 _mt-sm-60"
          >もし旅行中に費用が足りなくなったら？</HeadingTwo
        >

        <TalkGroup src="sv007/img06.jpg" class="_mb-sm-40 _mb-md-60">
          <TalkBox src="sv007/avatar-b.gif"
            >これで旅行費用はなんとかなりそう。でも旅行中にかかる費用は心配だな…。お金がなくなったからって、みんなに借りるのは申し訳ないし…</TalkBox
          >
          <TalkBox src="sv007/avatar-a.gif"
            >au PAY
            スマートローンなら、全国のセブン銀行ＡＴＭでお金が受け取れるよ</TalkBox
          >
        </TalkGroup>

        <TalkGroup class="_mb-60">
          <TalkBox src="sv007/avatar-b.gif"
            >そうなんだ！申し込みもスマートフォンでできるし、セブン銀行ATMなら旅先にもあるし便利だね</TalkBox
          >
          <TalkBox src="sv007/avatar-a.gif"
            >そうそう。au PAY
            スマートローンなら、auのサービスだし、知らないところから借りるわけじゃないので安心よね！</TalkBox
          >
          <TalkBox src="sv007/avatar-b.gif"
            >確かに！手続きも難しくないみたいだし、バイトのシフトを増やしてもらう相談をして、返済の目処を立てられれば、ローンも検討してみようかな。</TalkBox
          >
          <ListGroup class="-note">
            <ListItem class="-note"
              >au PAY
              スマートローンのご契約・ご利用には審査がございます。審査状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</ListItem
            >
          </ListGroup>
        </TalkGroup>

        <div class="container _mb-md-120 _mb-sm-60">
          <BtngroupSingle>
            <BtnMain class="-normal -lg" router-name="sv002"
              >au PAY スマートローンの特徴について</BtnMain
            >
          </BtngroupSingle>
        </div>
        <CvBox class="-cv _mb-md-120 _mb-sm-60" />
      </section>
    </div>

    <hr class="_mb-120 _mb-sm-60" />

    <div class="container">
      <HeadingTwo>おすすめ記事</HeadingTwo>

      <CardGroups class="-image-top-list">
        <CardBox router-name="sv053" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv053/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">"ちょっとだけ"がすごく助かる生活の工夫</h3>
          </CardHeader>
          <CardBody
            >ローンの借り入れ理由として多いのが、実は「日々の生活費」なんです！</CardBody
          >
        </CardBox>

        <CardBox router-name="sv008" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv008/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">急な飲み会・・・給料日前だけど参加したい！</h3>
          </CardHeader>
          <CardBody
            >お誘いが多いのはうれしいけど、飲み会の回数が重なると結構な出費に…。</CardBody
          >
        </CardBox>

        <CardBox router-name="sv006" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv006/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">結婚＆出産…お祝いは突然やってくる？</h3>
          </CardHeader>
          <CardBody
            >「お祝い」続きで資金不足に…せっかくのお祝いを諦める？</CardBody
          >
        </CardBox>
      </CardGroups>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import ContentsHeader from "@/components/contents/ContentsHeader";
import ContentsIntro from "@/components/contents/ContentsIntro";
import TalkGroup from "@/components/contents/TalkGroup";
import TalkBox from "@/components/contents/TalkBox";
import HeadingTwo from "@/components/heading/HeadingTwo";
import ContentsCard from "@/components/contents/ContentsCard";
import IconBox from "@/components/icons/IconBox";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CvBox from "@/components/box/CvBox";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardImage from "@/components/card/CardImage";
import CardBody from "@/components/card/CardBody";
export default {
  name: "Sv007",
  components: {
    BreadcrumbGroup,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    CvBox,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    IconBox,
    ContentsCard,
    HeadingTwo,
    TalkBox,
    TalkGroup,
    ContentsIntro,
    ContentsHeader,
  },
  setup() {
    setMeta({
      title:
        "せっかくの卒業旅行…お金のことで諦めないで！｜教えて！みんなのローン活用術！",
      description:
        "みんなのローンの活用術！旅行代金の前払いに。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,卒業旅行",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          routerName: "sv003",
        },
        {
          text: "教えて！みんなのローン活用術",
          routerName: "sv042",
        },
        {
          text: "せっかくの卒業旅行…お金のことで諦めないで！",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-card {
  > .card-body01 {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    > .txt01 {
      margin-bottom: 0px;
      @include mq-up(md) {
        text-align: center;
      }
    }
    > .card-groups {
      @include mq-up(md) {
        display: flex;
        justify-content: space-between;
      }
      > .card-box {
        @include mq-up(md) {
          width: 30%;
        }
        > .card-image {
          margin: 0 auto 20px;
          &.-width80 {
            max-width: 62%;
          }
          &.-width90 {
            max-width: 90%;
          }
        }
      }
    }
  }
}

.contents-card {
  > .card-body02 {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    > .txt01 {
      text-align: center;
      margin-bottom: 25px;
    }
    > .card-groups {
      @include mq-up(md) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      > .card-box {
        @include mq-up(md) {
          width: 50%;
        }
        > .card-image {
          margin: 0 auto 20px;
          &.-width80 {
            max-width: 62%;
          }
          &.-width90 {
            max-width: 90%;
          }
          &.-width100-sp {
            @include mq-down(md) {
              max-width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
